<div [ngClass]="{'no-margin selection-text-color': !(viewportService?.viewport$ | async)?.isMobile}">
  {{message}}
</div>
